export var Currency;
(function (Currency) {
    Currency["AUD"] = "AUD";
    Currency["CAD"] = "CAD";
    Currency["CHF"] = "CHF";
    Currency["CZK"] = "CZK";
    Currency["DKK"] = "DKK";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
    Currency["MXN"] = "MXN";
    Currency["NOK"] = "NOK";
    Currency["NZD"] = "NZD";
    Currency["PLN"] = "PLN";
    Currency["SEK"] = "SEK";
    Currency["USD"] = "USD";
})(Currency || (Currency = {}));
